module.exports = __webpack_public_path__ + "static/media/hourglass_top_green.1fe00c45.svg";